import {
  Input,
} from 'antd';
import {
  array, func, any,
} from 'prop-types';
import { useContext } from 'react';

import FormInput from 'components/formInput';
import FileUploader from 'components/fileUploader';
import { i18nContext } from 'context/i18n';

import { useValidate } from 'hooks';
import styles from 'styles/Contact.module.css';

export function ExtraInput({ items }) {
  return (
    items.map((contentItem, contentIndex) => {
      let content = null;

      if (contentItem.children) {
        content = contentItem.children;
      } else {
        content = <Input />;
      }

      return (
        <FormInput key={`fi-${contentIndex}`} {...contentItem}>
          {content}
        </FormInput>
      );
    }));
}
ExtraInput.propTypes = {
  items: array,
};

export const ExtraInputs = ({
  ContactForm, filesErrorsTicket, filesToUploadTicket, setFilesTicket, setFilesErrorsTicket,
}) => {
  const { t } = useContext(i18nContext);
  const validate = useValidate();

  return (
    <>
      <FormInput
        name="address"
        rules={validate('address')}
        floatLabel={t('contacto', 'direccion', 'Address')}
        required
      >
        <Input placeholder="" />
      </FormInput>
      <FormInput
        name="city"
        rules={validate('city')}
        floatLabel={t('contacto', 'poblacion', 'City')}
        required
      >
        <Input placeholder="" />
      </FormInput>
      <FormInput
        name="postalCode"
        rules={validate('postalCode')}
        floatLabel={t('contacto', 'codigo.postal', 'Postal code')}
        required
      >
        <Input placeholder="" />
      </FormInput>
      <div className='md:col-span-2'>
        <div
          className="text-[var(--color-text-secondary)] mb-6"
          dangerouslySetInnerHTML={{
            __html: t('contacto', 'anadir.ficheros.texto', 'Para poder atender su reclamación de una manera más eficaz, le pedimos que nos adjunte el ticket de compra y una fotografía del defecto. El ticket no será necesario si realizó su compra en camper.com'),
          }}
        />
        <div className={`${styles.fileUpload}`}>
          <FileUploader
            form={ContactForm}
            name='fichero'
            files={filesToUploadTicket}
            setFiles={setFilesTicket}
            errors={filesErrorsTicket}
            setErrors={setFilesErrorsTicket}
            minCount={1}
            maxCount={10}
            sizeLimitMB={50}
          />
        </div>
      </div>
    </>
  );
};

ExtraInputs.propTypes = {
  ContactForm: any,
  filesErrorsTicket: array,
  filesToUploadTicket: array,
  setFilesTicket: func,
  setFilesErrorsTicket: func,
};
